import { Editor } from 'slate'
import { IEditorPlugin } from '../EditorService'
import { DashboardElementDef } from '../elements'
import { DashboardCommands } from '../commands/DashboardCommands'
import { WidgetElementDef } from '../elements/WidgetElement'
import {
  attributeviewerWidget, calendarWidget, commentThreadWidget,
  graphChartWidget, groupedListWidget, kanbanWidget, mapWidget, pieChartWidget, statsTableWidget, tableViewerWidget, treeMapChartWidget,
} from '../widgets'

export const DashboardPlugin: IEditorPlugin = {
  handleKeyPress(e, service) {
    if (e.key === 'Enter') {
      const [match] = Editor.nodes(service.editor, { match: n => n.type === 'widget' })
      if (match) {
        e.preventDefault()
      }
    }
  },
  elements: {
    'dashboard': DashboardElementDef,
    'widget': WidgetElementDef,
  },
  widgets: [
    attributeviewerWidget,
    calendarWidget,
    commentThreadWidget,
    graphChartWidget,
    groupedListWidget,
    kanbanWidget,
    mapWidget,
    pieChartWidget,
    statsTableWidget,
    tableViewerWidget,
    treeMapChartWidget,
  ],
  commands: [
    { title: 'Add Dashboard', handler: (e, s) => DashboardCommands.addDashboard(s) },
    { title: 'Add Widget', handler: (e, s) => DashboardCommands.addWidgetClean(e, s) },
  ],
}
